<template>
  <VanPopup
    :show="show"
    position="bottom"
    class="max-h-[80%]"
    @update:show="emit('update:show', $event)"
  >
    <div class="flex justify-end gap-2 p-2">
      <button
        class="btn btn-primary btn-sm"
        @click="mateStore.clickCreateMate()"
      >
        {{ $t(`Buttons.create`) }} OC
      </button>
      <button
        class="btn btn-outline btn-sm"
        @click="emit('update:show', false)"
      >
        {{ $t(`Buttons.cancel`) }}
      </button>
    </div>
    <DungeonsHomeMyMate @update:show="emit('update:show', $event)" />
  </VanPopup>
</template>

<script setup lang="ts">
import { useMate } from "@/stores/mate";

defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  (e: "update:show", show: boolean): void;
}>();

const mateStore = useMate();
</script>
